import { render, staticRenderFns } from "./MaTestModal.vue?vue&type=template&id=22d15d44"
import script from "./MaTestModal.vue?vue&type=script&lang=js"
export * from "./MaTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports